import { gql } from 'apollo-angular';

export const SEND_WELCOME_EMAIL_MUTATION = gql`
  mutation RetriggerOnboarding($email: String!) {
    retriggerOnboarding(email: $email) {
      isSuccess
      message
      data
      errorCode
    }
  }
`;
